export type OverlaySurfaceRole = 'menu' | 'dialog';

const overlaySurfaceRoleClassNames: Record<OverlaySurfaceRole, string> = {
  // Keep the public utilities in the built stylesheet and tailwind-merge graph.
  menu: 'monkeys-overlay-surface--menu bg-menu-surface text-popover-foreground',
  dialog: 'monkeys-overlay-surface--dialog bg-dialog-surface text-foreground',
};

export function getOverlaySurfaceClassName(
  role: OverlaySurfaceRole,
  options: { rounded?: boolean } = {},
) {
  return [
    'monkeys-overlay-surface',
    overlaySurfaceRoleClassNames[role],
    options.rounded === false ? undefined : 'monkeys-overlay-surface--rounded',
  ]
    .filter(Boolean)
    .join(' ');
}
